import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { C, FONT, ghostBtnRed } from "./admin_ui";

const navTabs = [
  { to: "/miadmin", label: "대시보드", end: true },
  { to: "/miadmin/users", label: "회원" },
  { to: "/miadmin/matches", label: "수리 요청" },
  { to: "/miadmin/communities", label: "커뮤니티" },
  { to: "/miadmin/services", label: "1:1 문의" },
  { to: "/miadmin/notices", label: "공지" },
  { to: "/miadmin/reports", label: "신고" },
  { to: "/miadmin/blocks", label: "차단" },
  { to: "/miadmin/points", label: "포인트" },
  { to: "/miadmin/ratings", label: "평점" },
  { to: "/miadmin/stats", label: "통계" },
  { to: "/miadmin/settings", label: "설정" },
];

function tabStyle(isActive) {
  return {
    padding: "7px 14px",
    borderRadius: 8,
    border: "none",
    background: isActive ? "#fff" : "transparent",
    color: isActive ? C.greenDark : C.sub,
    fontSize: 13,
    fontWeight: 700,
    cursor: "pointer",
    boxShadow: isActive ? "0 1px 3px rgba(0,0,0,0.06)" : "none",
    transition: "all 0.15s ease",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
  };
}

export default function AdminLayout({ onLogout }) {
  const navigate = useNavigate();
  return (
    <div
      style={{
        fontFamily: FONT,
        background: C.bg,
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderBottom: `1px solid ${C.line}`,
          position: "sticky",
          top: 0,
          zIndex: 5,
        }}
      >
        <div
          style={{
            maxWidth: 1280,
            margin: "0 auto",
            padding: "14px 20px",
            display: "flex",
            alignItems: "center",
            gap: 14,
            flexWrap: "wrap",
          }}
        >
          <div
            onClick={() => navigate("/miadmin")}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              cursor: "pointer",
            }}
          >
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: 8,
                background: `linear-gradient(135deg, ${C.greenDark}, #064E3B)`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontWeight: 800,
              }}
            >
              🛠
            </div>
            <div>
              <div
                style={{
                  fontSize: 16,
                  fontWeight: 800,
                  color: C.ink,
                  letterSpacing: "-0.01em",
                }}
              >
                뚝딱이 관리자 콘솔
              </div>
              <div style={{ fontSize: 11, color: C.sub }}>
                실시간 운영 데이터 — DB(MSSQL) 직접 조회
              </div>
            </div>
          </div>
          <div style={{ flex: 1 }} />
          <div
            style={{
              display: "flex",
              gap: 4,
              background: C.bg,
              borderRadius: 10,
              padding: 4,
              flexWrap: "wrap",
            }}
          >
            {navTabs.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.end}
                style={({ isActive }) => tabStyle(isActive)}
              >
                {t.label}
              </NavLink>
            ))}
          </div>
          <button type="button" onClick={onLogout} style={ghostBtnRed}>
            로그아웃
          </button>
        </div>
      </div>

      <div
        style={{
          maxWidth: 1280,
          margin: "0 auto",
          padding: "24px 20px 80px",
          display: "flex",
          flexDirection: "column",
          gap: 20,
        }}
      >
        <Outlet />
      </div>
    </div>
  );
}
